import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { AccountType } from 'utils/enums/misc';

export interface initialStateI {
  permission: string[];
  userProfile: {
    first_name: string;
    last_name: string;
    email: string;
    user_id: number;
    email_configurations: boolean;
    account_type: AccountType
  };
}

const initialState: initialStateI = {
  permission: [],
  userProfile: {
    first_name: '',
    last_name: '',
    email: '',
    user_id: 0,
    email_configurations: false,
    account_type: AccountType.USER
  }
};

export const profileSlice = createSlice({
  name: 'profileSlice',
  initialState: initialState,
  reducers: {
    setPermissionList: (
      state: initialStateI,
      action: PayloadAction<initialStateI['permission']>
    ) => {
      state.permission = action.payload;
    },
    setUserData: (
      state: initialStateI,
      action: PayloadAction<initialStateI['userProfile']>
    ) => {
      state.userProfile = action.payload;
    }
  }
});
